import React, { FunctionComponent } from "react";
import { Layout, Typography } from "antd";
import { HeartFilled } from "@ant-design/icons";
import AppRoute from "./AppRoute";
import styles from "./app.style.less";
import { BrowserRouter as Router } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { messages } from "../utils/locale";
import dayjs from "dayjs";
import LocaleSelect from "./Header/LocaleSelect";
import ReactLoveIcon from "components/utilities/LogoIcon";
import { Link } from "react-router-dom";
import { routePath } from "utils/config";
import MenuSidebar from "./Sidebar/Menu";

const { Header, Content, Footer, Sider } = Layout;
const { Title } = Typography;

const AppLayout: FunctionComponent = () => (
    <Router>
        <Layout>
            <Sider breakpoint="lg" collapsedWidth="0">
                <Link to={routePath.HOME} className={styles.logo}>
                    <ReactLoveIcon className={styles.logoIcon} />
                    <Title copyable={false} level={3} className={styles.logoText}>
                        React Fortune
                    </Title>
                </Link>
                <MenuSidebar />
            </Sider>
            <Layout className={styles.appLayout}>
                <Header className={styles.appHeader}>
                    <div className={styles.headerRight}>
                        <LocaleSelect />
                    </div>
                </Header>
                <Content className={styles.appContent}>
                    <AppRoute />
                </Content>
                <Footer className={styles.appFooter}>
                    <FormattedMessage {...messages.app.footer} values={{ year: dayjs().year() }} />{" "}
                    <HeartFilled className={styles.heartIcon} />
                </Footer>
            </Layout>
        </Layout>
    </Router>
);

export default AppLayout;
